<template>
    <div class="authorCenter" :style="isshowlogin?'height:100vh;overflow:hidden':''">
        <Header :isbig="true" @changeLogin="changeLogin"></Header>
        <div class="authorBox flexible createBox">
            <div class="left">
                <div class="upload-cover">
                    <div class="avatar-uploader">
                        <div class="el-upload el-upload--text">
                            <img v-if="form.iconTempFile == ''" src="@/assets/author/img-no.png">
                            <img v-if="form.iconTempFile != ''" :src="form.iconTempFile">
                        </div>
                        <input type="file" name="file" @change="uploadFun" class="el-upload-input"
                            accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                    </div>
                    <div class="f14 font-MT  text-333 mt20 pl48">尺寸：400*560px</div>
                    <div class="f14 font-MT  text-333 mt5 pl48">类型：.jpg .png</div>
                    <div class="avatar-uploader upload-btn-info mt20">
                        <div class="el-upload el-upload--text">
                            <el-button class="upload-btn f16 font-MT" type="success" size="medium">上传封面</el-button>
                        </div>
                        <input type="file" name="file" @change="uploadFun" class="el-upload-input"
                            accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                    </div>
                </div>
            </div>
            <div class="right flex">
                <div class="page-title font-MT ">
                    <img class="fh-img" src="@/assets/ic_fh.png" alt="" @click="goBack()">
                    <span class="f22 page-name text-333 fwb-600">作品信息</span>
                </div>
                <el-form :model="form" ref="form" class="create-form" :rules="rules">
                    <!-- :rules="this.$route.params.id != '0'?rules:{}" :inline-message="true" -->
                    <el-form-item label="作品名称" prop="name">
                        <el-input placeholder="请输入70个字以内的作品名称" v-model="form.name">
                        </el-input>
                        <div class="f12 text-999 name-lenght">0/70</div>
                    </el-form-item>
                    <el-form-item label="分类" prop="sort">
                        <el-select style="width: 100%;" v-model="form.sort" placeholder="请选择作品类型">
                            <el-option v-for="item in sortList" :key="item.value" :label="item.desc"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="编辑" prop="editorId">
                        <el-select style="width: 100%;" v-model="form.editorId"
                            placeholder="请选择编辑，她/他将会帮助你提交书的内容进行评审。">
                            <el-option v-for="item in editorList" :key="item.userId"  :label="item.nickName"
                                :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="签约类型" prop="first">
                        <el-radio-group class="m-l-0 m-b-0" v-model="form.first">
                            <el-radio :label="true">独家</el-radio>
                            <el-radio :label="false">非独家</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="作品类型" prop="bookType">
                        <el-radio-group class="m-l-0 m-b-0" v-model="form.bookType" :disabled="bookId !== '0'?true:false">
                            <el-radio :label="1">短篇</el-radio>
                            <el-radio :label="2">中篇</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="男女频" prop="classify">
                        <el-radio-group class="m-l-0 m-b-0" v-model="form.classify">
                            <el-radio :label="1">男频</el-radio>
                            <el-radio :label="2">女频</el-radio>
                        </el-radio-group>
                    </el-form-item>
<!--                    <el-form-item label="作品简介" prop="introduce">-->
<!--                        <el-input placeholder="请输入20-300字以内作品简介，请不要填写和作品无关的内容！" v-model='form.introduce' type="textarea"-->
<!--                            rows="6"></el-input>-->
<!--                    </el-form-item>-->
                    <el-form-item label="标签" prop="tags">
                        <el-select placeholder="请最多添加5个作品标签" v-model="form.tags" multiple :multiple-limit="5" filterable
                            allow-create default-first-option style="width: 100%;">
                            <el-option v-for="(item,indnx) in tagLists" :key="indnx" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="text-align: center;">
                        <el-button class=" creat-btn  f16 font-MT mt20" @click="createFun('form')">
                            {{bookId != '0'?'修改':'创建'}}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <Login v-if="isshowlogin" @changeLogin="changeLogin"></Login>
    </div>
</template>

<script>
    // import {
    //     isWords
    // } from "utils/core/kernel";
    import {
        sortListApi,
        editorListApi,
        tagsListApi,
        addBookApi,
        getbookinfoApi,
        editbookApi
    } from "apiurl/author";
    import baseURL from "@/api/env.js";
    import {
        getToken
    } from "utils/storage";
    import index from '@/mixins/index'
    import {
        hideLoading,
        showLoading
    } from "../utils/load";
    export default {
        // name: "",
        data() {
            return {
                /*token*/
                token: getToken() || null,
                bookId: '',
                backupsform: {},
                /*添加*/
                form: {
                    name: "",
                    sort: "",
                    editorId: "",
                    first: true,
                    classify: 1,
                    bookType:1,
                    // introduce: "",
                    tags: [],
                    iconTempFile: ""
                },
                rules: {
                    name: [{
                            required: true,
                            message: '请输入作品名称',
                            trigger: 'blur'
                        },
                        {
                            min: 1,
                            max: 70,
                            message: '请输入70字以内作品名称',
                            trigger: 'blur'
                        },
                    ],
                    sort: [{
                        required: true,
                        message: "请选择分类",
                        trigger: "change"
                    }, ],
                    editorId: [{
                        required: true,
                        message: "请选择编辑",
                        trigger: "change"
                    }, ],
                    bookType: [{
                        required: true,
                        message: "请选择作品类型",
                        trigger: "change"
                    }, ],
                    // introduce: [{
                    //         required: true,
                    //         message: '请输入作品简介',
                    //         trigger: 'blur'
                    //     },
                    //     {
                    //         min: 20,
                    //         max: 300,
                    //         message: '请输入20-300字以内作品简介',
                    //         trigger: 'blur'
                    //     },
                    // ],
                    tags: [{
                        required: true,
                        message: "请选择标签",
                        trigger: "change"
                    }, ],
                },

                firstList: [{ //首发
                        value: true,
                        label: "首发"
                    },
                    {
                        value: false,
                        label: "非首发"
                    }
                ],
                publicationList: [{ //是否出版
                        value: false,
                        label: "未出版"
                    },
                    {
                        value: true,
                        label: "已出版"
                    }
                ],
                sortList: [],
                editorList: [],
                tagLists: [],
                /*上传图片*/
                uploadurl: '',
                saveFlag: false
            }
        },
        created() {
            this.bookId = this.$route.params.id
        },
        mounted() {
            this.getsortlist()
            this.geteditorlist()
            this.gettags()
            this.backupsform = JSON.stringify(this.form)
            if (this.bookId !== '0') {
                this.getbookInfo()
            }
        },
        mixins: [index],
        methods: {
            goBack() {
                history.back()
            },
            /*修改获取信息*/
            async getbookInfo() {
                let res = await getbookinfoApi(this.bookId);
                if (res.success) {
                    this.form = {
                        name: res.data.iname,
                        sort: res.data.isort == 0 ? '' : res.data.isort,
                        editorId: res.data.editorId,
                        first: res.data.ifirst,
                        classify: res.data.classify,
                        // introduce: res.data.iintroduce,
                        iconTempFile: res.data.iconUrl,
                        tags: res.data.itags != '' ? res.data.itags.split(',') : [],
                        bookType:res.data.type
                    }
                    this.backupsform = JSON.stringify(this.form)
                }
            },
            /* 获取分类 */
            async getsortlist() {
                let res = await sortListApi();
                if (res.success) {
                    this.sortList = res.data;
                }
            },
            /* 获取责编 */
            async geteditorlist() {
                let res = await editorListApi();
                if (res.success) {
                    this.editorList = res.data;
                }
            },
            // 获取tags
            async gettags() {
                let res = await tagsListApi();
                if (res.success) {
                    this.tagLists = res.data;
                }
            },
            /*****上传图片*********/
            uploadFun(e, code) {
                if (!this.token) {
                    this.isshowlogin = true
                    return false
                } else if (e.target.files.length == 0) {
                    this.$faild('custom', '请选择要上传的图片')
                    return false
                }
                let file = e.target.files[0];
                // this.form.iconTempFile = window.URL.createObjectURL(e.target.files[0]);
                // 上传图片地址
                this.uploadurl = `${baseURL.AHEAD}/book/core/pc/add/icon`;
                let fileFormData = new FormData();
                fileFormData.append("file", file);
                showLoading()
                this.uploadImgFun('post', this.uploadurl, fileFormData).then(res => {
                    hideLoading()
                    if (res.success) {
                        this.form.iconTempFile = res.data
                    } else {
                        this.$faild('operation')
                    }
                })
            },
            /*****保存*****/
            createFun(form) {
                if (!this.token) {
                    this.isshowlogin = true
                    return false
                }
                this.$refs[form].validate(valid => {
                    if (valid) {
                        this.form.tags = this.form.tags ? this.form.tags.join(',') : ''
                        if (this.bookId != '0') {
                            this.form.bookId = this.bookId
                            editbookApi(this.qs.stringify(this.form))
                                .then(res => {
                                    this.form.tags = this.form.tags ? arrFun(this.form.tags, 'string') :
                                            '';
                                    if (res.success) {
                                        this.$success('custom', '修改成功!')
                                        this.saveFlag = true
                                        // this.$router.push('/author')
                                        history.back()
                                    } else {
                                        // this.form.tags = this.form.tags ? arrFun(this.form.tags, 'string') :
                                        //     ''
                                    }
                                })
                                .catch(() => {});
                        } else {
                            // this.qs.stringify(this.form)
                            addBookApi(this.qs.stringify(this.form))
                                .then(res => {
                                    this.form.tags = this.form.tags ? arrFun(this.form.tags, 'string') :
                                            '';
                                    if (res.success) {
                                        this.$success('custom', '创建成功!')
                                        this.saveFlag = true
                                        history.back()
                                    } else {
                                        // this.form.tags = this.form.tags ? arrFun(this.form.tags, 'string') :
                                        //     '';
                                    }
                                })
                                .catch(() => {});
                        }

                        function arrFun(data, flag) {
                            let arrN = []
                            let arr = data
                            let bv = arr.split(',')
                            if (flag == 'num') {
                                bv.forEach(item => {
                                    arrN.push(+item);
                                });
                            } else {
                                arrN = bv
                            }
                            return arrN
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },

        },
    }
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";
</style>
